import SUApi from './_summaryApi';

class GLVoucherListApi extends SUApi {
  controllerName = 'sugeneralvouchers';
  /**
   * Lấy dữ liệu detail cho Phiếu kết chuyển
   * ntban - 30.6.2023
   * lấy dữ liệu theo trang
   * htthoa 18.1.2024
   * @param {} payload
   * @returns
   * @modified nvthinh 22.2.2024: Thêm tham số paramForNewAction
   */
  getBalances(payload, take, skip, paramForNewAction) {
    var url = this.getAPIUrl();
    const request = {
      url: `${url}/GetBalance?skip=${skip}&take=${take}&paramForNewAction=${paramForNewAction}`,
      data: payload,
    };
    return this.postAsync(request);
  }

  /**
   * @description Kiểm tra xem loại Kết chuyển / Quyết toán đã được lưu trong năm hay chưa
   * @author nvthinh 11.07.2023
   * @returns Thông tin master của phiếu kết chuyển
   */
  checkExistTransferVoucher(refType, postedYear) {
    const request = {
      url: this.getAPIUrl() + '/CheckExistTransferVoucher',
      data: {refType, postedYear},
    };

    return this.getAsync(request);
  }

  /**
   * Lấy danh sách hướng dẫn quyết toán kết chuyển
   * VDDONG 06/01/2025
   */
  getListInstructionsAccountTransfer(postedYear) {
    const request = {
      url: this.getAPIUrl() + '/ListInstructionsAccountTransfer',
      data: {postedYear},
    };

    return this.getAsync(request);
  }

  /**
   * @description Lấy ra danh sách Kết chuyển / Quyết toán đã được sinh trong năm
   * @author ntban 17.07.2023
   * @returns
   */
  getTransferVoucher(refType, postedYear) {
    const request = {
      url: this.getAPIUrl() + '/GetTransferVoucher',
      data: {refType, postedYear},
    };

    return this.getAsync(request);
  }

  /**
   * @description Lấy ra danh sách Kết chuyển / Quyết toán đã được sinh trong năm
   * @author vqphong - 04/04/2025
   */
  getCurrentTransferVoucherList(refType, postedYear) {
    const request = {
      url: this.getAPIUrl() + '/cur-transfer-voucher-list',
      data: {refType, postedYear},
    };

    return this.getAsync(request);
  }

  /**
   * @description Sinh Kết chuyển / Quyết toán
   * @author ntban 17.07.2023
   * @returns
   */
  quickAddTransferVoucher(refType, postedDate) {
    const request = {
      url: this.getAPIUrl() + '/QuickAddTransferVoucher',
      data: {refType, postedDate},
    };

    return this.getAsync(request);
  }

  /**
   * Lấy dữ liệu từ cache (Phòng trường hợp websocket chết)
   * @param {String} traceId ID tiến trình worker
   * @author nvthinh 29.1.2024
   */
  checkQuickTransfer(traceId) {
    const request = {
      url: [this.getAPIUrl(), 'check-quick-transfer', traceId].join('/'),
    };
    return this.getAsync(request);
  }

  /**
   * Thực hiện kết chuyển nhanh
   * @param {} payload
   * @returns
   */
  makeQuickTransfers(payload) {
    const request = {url: [this.getAPIUrl(), '/make-quick-transfers'].join(''), data: payload};
    return this.postAsync(request);
  }

  /**
   * lấy dữ liệu chỉnh sửa
   * htthoa 18.1.2024
   * theo phân trang
   * @param {*} listEdit
   * @param {*} id
   * @param {*} skip
   * @param {*} take
   * @returns
   */
  getEditPaging(listEdit, id, skip, take) {
    const url = this.getAPIUrl();
    const request = {
      url: `${url}/edit-voucher?id=${id}&skip=${skip}&take=${take}`,
      data: listEdit,
    };
    return this.postAsync(request);
  }
  /**
   * lấy trang có bản ghi lỗi đầu tiên
   * htthoa 20.2.2024
   * @param {*} id
   * @param {*} skip
   * @param {*} take
   * @returns
   */
  getPageNumberErrorPost(id, skip, take) {
    const url = this.getAPIUrl();
    const request = {
      url: `${url}/get-page-error-post?ref_detail_id=${id}&skip=${skip}&take=${take}`,
    };
    return this.getAsync(request);
  }
}

export default new GLVoucherListApi();
